import { CultureInfo } from '../culture-info.model';
import { CultureInfoEs } from './es';

/**
 * @ignore
 */
export const CultureInfoEsAR: CultureInfo = {
  name: 'es-AR',
  displayName: 'Spanish (Argentina)',
  iso3LanguageCode: 'spa',
  iso2LanguageCode: 'es',
  ietfLanguageTag: 'es-AR',
  parent: CultureInfoEs
};
